/* TODO A process overwrites variables named as environments */
// ['development', 'testing', 'staging', 'production']
const environments = {
    dev: 'dev',
    test: 'test',
    stag: 'stag',
    prod: 'prod'
};

const ENABLE_VALIDATE_CVU = ['true', '1'].includes(process.env.ENABLE_VALIDATE_CVU);
const ENABLE_CUOTITAS_CC = [environments.dev, environments.prod].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env));
const ENABLE_DOWNLOAD_REPORT_ERROR = [environments.dev, environments.test].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env));
const ENABLE_GOOGLE_ANALYTICS = [environments.stag, environments.prod].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env));
const ENABLE_INSTALLMENTS_WITE_DATE = [environments.dev, environments.test, environments.stag, environments.prod].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env));
const ENABLE_MOCK = false;
const ENABLE_PERSON_MOCK = [environments.dev].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env));
const ENABLE_GET_INSTALLMENTS_DATABASE = [environments.dev, environments.test].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env));
const ENABLE_GET_INSTALLMENTS = [].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env));
// [environments.dev].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env));
// const ENABLE_MOCK = true;
const ENABLE_GET_PERSON_BANK = [environments.dev, environments.test, environments.stag, environments.prod].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env));
const ENABLE_INSTALLMENTS_SECOND_CALL = [].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env));

export default {
    validateCVU: !!Number(ENABLE_VALIDATE_CVU),
    enableCuotitasCC: ENABLE_CUOTITAS_CC,
    enableDownloandReportError: ENABLE_DOWNLOAD_REPORT_ERROR,
    enableGoogleAnalytics: ENABLE_GOOGLE_ANALYTICS,
    enableInstallmentsWithDate: ENABLE_INSTALLMENTS_WITE_DATE,
    enableMock: ENABLE_MOCK,
    enableGetPersonBank: ENABLE_GET_PERSON_BANK,
    enablePersonBankMock: ENABLE_PERSON_MOCK,
    enableGetInstallmentsDatabase: ENABLE_GET_INSTALLMENTS_DATABASE,
    enableInstallmentsSecondCall: ENABLE_INSTALLMENTS_SECOND_CALL,
    enableGetInstallments: ENABLE_GET_INSTALLMENTS,
};
